import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  handleCheckboxToggle(event) {
    const button = this.buttonTarget
    button.disabled = !event.target.checked
  }
}
